'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'ice-cream';
var width = 448;
var height = 512;
var aliases = [127848];
var unicode = 'f810';
var svgPathData = 'M112 160c0-61.9 50.1-112 112-112S336 98.1 336 160c0 4-.2 8-.6 11.8l-1.8 17.7 16.3 6.9C370 205 384 224.9 384 248l0 24-320 0 0-24c0-23.1 14-43 34.1-51.6l16.3-6.9-1.8-17.7c-.4-3.9-.6-7.8-.6-11.8zM224 0C135.6 0 64 71.6 64 160l0 .4C35.2 178.8 16 211.2 16 248l0 72 82 0 126 224 126-224 82 0 0-72c0-36.8-19.2-69.2-48-87.6l0-.4C384 71.6 312.4 0 224 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIceCream = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;